import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
const brandClasses = {
  base: 'Union__brands-v1__base',
  'theknot-primary-color': 'Union__brands-v1__theknot Union__brands-v1--color-primary',
  'theknot-secondary-color': 'Union__brands-v1__theknot Union__brands-v1--color-secondary'
};

const BrandLogo = _ref => {
  let {
    color,
    size = 'lg',
    name,
    nameForId = name,
    nameForClasses = name,
    className = '',
    ...props
  } = _ref;
  const colorClass = brandClasses[`${nameForClasses}-${color}-color`] || '';
  const ownClassName = `Union__brands-v1__icon-${nameForClasses}_${size}`;
  const id = `Union__brands-v1__icon-${nameForId}_${size}`;
  const classes = [brandClasses.base, className, colorClass, ownClassName].join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: classes,
    "aria-labelledby": `${id}_title`,
    role: "img"
  }, props), /*#__PURE__*/React.createElement("use", {
    xlinkHref: `#${id}`
  }));
};

export default BrandLogo;